<template>
  <div class="boot-shell" role="status" aria-live="polite">
    <div class="boot-shell__brand" aria-hidden="true">
      <svg viewBox="0 0 48 48" width="52" height="52" fill="none">
        <rect width="48" height="48" rx="14" fill="#08B578" />
        <path d="M10 25h7l3-7 5 15 4-9h9" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <p class="boot-shell__title">康护健康</p>
    <p class="boot-shell__text">正在准备运营工作台</p>
    <span class="boot-shell__bar"><i></i></span>
  </div>
</template>
